// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3QZ4L","bigColWidth":"Table_bigColWidth__awwz-","biggerColWidth":"Table_biggerColWidth__3r0o4","row":"Table_row__3vHiw","col":"Table_col__3Psjf"};